import { Layout, Skeleton } from "../../components/ui";
import { useDeleteActivity, useGetActivityById } from "../../query/activityQuery";
import { useNavigate, useParams } from "react-router-dom";
import swal from "../../utils/swal";
import ActivityProfile from "./ActivityProfile";

function ActivityDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isLoading, data: activity } = useGetActivityById(id);
  const { mutate: deleteActivity } = useDeleteActivity();

  const handleDelete = () => {
    swal({
      title: "Are you sure?",
      text: "Do you want to delete this activity?",
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, I am sure!"],
      dangerMode: true,
    }).then((isConfirm) => {
      if (!isConfirm) return;
      deleteActivity(id, {
        onSuccess: () => {
          swal("Success", "Activity deleted successfully", "success");
          navigate("/activities");
        },
        onError: (error) => {
          swal("Cannot delete", error?.message || "Failed to delete activity", "error");
        },
      });
    });
  };

  return (
    <Layout className="configuration">
      <div
        className="boxDetails"
        style={{ background: "transparent", padding: 0, boxShadow: "none" }}
      >
        {isLoading && (
          <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
            <Skeleton active paragraph={{ rows: 10 }} />
          </div>
        )}

        {!isLoading && activity && <ActivityProfile activity={activity} onDelete={handleDelete} />}
      </div>
    </Layout>
  );
}

export default ActivityDetails;
